export const JOB_UPDATE_TYPES = {
  ACTIVATE: 'ACTIVATE'
};
